if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector("form");
        this.submitButton = this.querySelector('[type="submit"]');
        this.quickBuy = false;
        this.errorMessage = this.querySelector(".product-form__error-message");
      }

      connectedCallback() {
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        if (document.querySelector("cart-drawer")) {
          this.submitButton.setAttribute("aria-haspopup", "dialog");
        }
      }

      trackAddToCart(addedCartItem, formData) {
        try {
          const itemProperties = addedCartItem.properties || {};
          const ecommerceProduct = {
            id: addedCartItem.product_id,
            name: addedCartItem.product_title,
            variant: addedCartItem.variant_id,
            price: addedCartItem.price / 100,
            currency: theme.cart.currency, // must be the customer's selected currency not shop currency
            quantity: formData.get("quantity") || 1, // must be the quanity added not the total quantity
            brand: addedCartItem.vendor,
            is_free_trial: Boolean(itemProperties._is_free_trial),
            is_custom_bundle_item: Boolean(itemProperties["_my-bundle"]),
            category: addedCartItem.product_type,
            subscription_interval:
              (addedCartItem.properties &&
                addedCartItem.properties._interval) ||
              null,
          };

          layerPush({ ecommerce: null });

          if (this.getAttribute('data-upsell-type')) {
            layerPush({
              event: "upsellTaken",
              upsellEventData: {
                type: this.dataset.upsellType,
                productName: addedCartItem.product_title,
              },
            });
          }

          return layerPush({
            event: "ecommerceCartAdd",
            ecommerce: {
              add: { products: [ecommerceProduct] },
            },
          });
        } catch (e) {
          logger.error(`Error tracking AddToCart: ${e}`);
        }
      }

      async showOutOfStockModal(productVariantId) {
        const oosModal = document.getElementById("OutOfStock-modal");
        if (oosModal) {
          oosModal.show();
          trackOutOfStockModalShown(productVariantId);
          return;
        }
        this.setLoading();
        try {
          const modalContent = await apiFetchText(
            "",
            `?section_id=product-out-of-stock-modal`
          );
          document.getElementById("modal-container").innerHTML = modalContent;
          document.getElementById("OutOfStock-modal").show();
          trackOutOfStockModalShown(productVariantId);
        } catch (error) {
          logger.error(error);
        } finally {
          this.setLoading(false);
        }
      }

      shouldShowOutOfStockModal(productVariantId) {
        const oosModalVariants = theme.shop.out_of_stock_modal_variants;
        return (
          Array.isArray(oosModalVariants) &&
          oosModalVariants.includes(Number(productVariantId))
        );
      }

      async getDrawer() {
        if (window.cartDrawer) {
          this.cart = window.cartDrawer;
        } else {
          window.cartDrawer = await fetchDrawer();
          this.cart = window.cartDrawer;
        }
      }

      setLoading(isLoading = true, submitter = null) {
        if (isLoading) {
          if (submitter) submitter.classList.add("loading");
          this.submitButton.setAttribute("aria-disabled", true);
        } else {
          this.querySelectorAll('[type="submit"]').forEach((btn) =>
            btn.classList.remove("loading")
          );
          this.submitButton.removeAttribute("aria-disabled");
        }
      }

      handleResponseError(response) {
        this.handleErrorMessage(response.description);
        const soldOutMessage =
          this.submitButton.querySelector(".sold-out-message");
        if (!soldOutMessage) return;
        this.submitButton.querySelector("span").classList.add("hidden");
        soldOutMessage.classList.remove("hidden");
        this.error = true;
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        if (document.querySelector("my-bundle")) {
          document.querySelector("my-bundle").dispatchEvent(
            new CustomEvent("submit-started", {
              bubbles: true,
            })
          );
        }
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;
        this.handleErrorMessage();
        const formData = new FormData(this.form);
        const variantId = formData.get("id");
        const isByob = !!evt.target.dataset.byob;
        this.setLoading(true, evt.submitter);
        await this.getDrawer();
        if (this.shouldShowOutOfStockModal(variantId)) {
          this.showOutOfStockModal(variantId);
          return;
        }
        if (evt.submitter.dataset.quickBuy === "true") {
          this.quickBuy = true;
        }
        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleResponseError(response);
              return;
            }
            let productLimit = 0;
            try {
              productLimit = parseInt(response.properties["_productLimit"]);
            } catch (e) {}
            if (productLimit > 0 && response.quantity > productLimit) {
              this.error = true;
              config.body.set("quantity", productLimit);
              fetch(`${routes.cart_change_url}`, config).then(() => {
                /* fix SonarQube warning */
              });
              this.handleErrorMessage(
                window.cartStrings.quantityError.replace(
                  "[quantity]",
                  productLimit
                )
              );
              this.submitButton.disable = true;
              if (evt.submitter.dataset.quickBuy === "true") {
                evt.submitter.classList.remove("loading");
              }
              return;
            }
            this.error = false;
            this.closeModal();
            if (isByob) {
              this.cart.renderContents(response, false);
            } else {
              this.cart.renderContents(response);
            }
            this.trackAddToCart(response, formData);
            document.dispatchEvent(new CustomEvent("reload-variant-listener"));
          })
          .catch((e) => {
            showLoader(false);
            console.error(e);
          })
          .finally(() => {
            if (document.querySelector("my-bundle")) {
              document.querySelector("my-bundle").dispatchEvent(
                new CustomEvent("submit-finished", {
                  bubbles: true,
                })
              );
            }
            this.setLoading(false);
            this.handleFinally();
          });
      }
      closeModal() {
        if (
          this.dataset.closeModal === "true" &&
          this.closest("modal-dialog")
        ) {
          this.closest("modal-dialog").hide();
        }
      }
      handleFinally() {
        if (this.quickBuy) {
          this.cart.style.visibility = "hidden";
        }
        if (this.cart && this.cart.classList.contains("is-empty"))
          this.cart.classList.remove("is-empty");
        if (!this.error) this.submitButton.removeAttribute("aria-disabled");
        if (this.quickBuy === true) {
          this.cart.querySelector(".cart__checkout-button").click();
          showLoader(true);
        }
      }
      handleErrorMessage(errorMessage = "") {
        if (errorMessage) {
          this.errorMessage.toggleAttribute("hidden", !errorMessage);
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
